export default __webpack_public_path__ + "static/media/list.b36374b0.svg";